function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import r, { OPTIONS as z } from "../../managers/braze-instance.js";
import ro from "../../util/browser-detector.js";
import { clickElement as Et, supportsPassive as Tt } from "../../util/dom-utils.js";
import { KeyCodes as bt } from "../../util/key-codes.js";
import u from "../../managers/subscription-manager.js";
import { isIFrame as It } from "../utils/in-app-message-utils.js";

var InAppMessage = /*#__PURE__*/function () {
  function InAppMessage(t, s, i, h, e, E, n, T, o, r, l, a, I, c, A, O, _, m, L, N, S, R, M, D, C, d, U, b, P, p) {
    _classCallCheck(this, InAppMessage);

    this.message = t, this.messageAlignment = s, this.slideFrom = i, this.extras = h, this.triggerId = e, this.clickAction = E, this.uri = n, this.openTarget = T, this.dismissType = o, this.duration = r, this.icon = l, this.imageUrl = a, this.imageStyle = I, this.iconColor = c, this.iconBackgroundColor = A, this.backgroundColor = O, this.textColor = _, this.closeButtonColor = m, this.animateIn = L, this.animateOut = N, this.header = S, this.headerAlignment = R, this.headerTextColor = M, this.frameColor = D, this.buttons = C, this.cropType = d, this.orientation = U, this.htmlId = b, this.css = P, this.messageExtras = p, this.message = t, this.messageAlignment = s || InAppMessage.TextAlignment.CENTER, this.duration = r || 5e3, this.slideFrom = i || InAppMessage.SlideFrom.BOTTOM, this.extras = h || {}, this.triggerId = e, this.clickAction = E || InAppMessage.ClickAction.NONE, this.uri = n, this.openTarget = T || InAppMessage.OpenTarget.NONE, this.dismissType = o || InAppMessage.DismissType.AUTO_DISMISS, this.icon = l, this.imageUrl = a, this.imageStyle = I || InAppMessage.ImageStyle.TOP, this.iconColor = c || InAppMessage.th.ih, this.iconBackgroundColor = A || InAppMessage.th.sh, this.backgroundColor = O || InAppMessage.th.ih, this.textColor = _ || InAppMessage.th.hh, this.closeButtonColor = m || InAppMessage.th.eh, this.animateIn = L, null == this.animateIn && (this.animateIn = !0), this.animateOut = N, null == this.animateOut && (this.animateOut = !0), this.header = S, this.headerAlignment = R || InAppMessage.TextAlignment.CENTER, this.headerTextColor = M || InAppMessage.th.hh, this.frameColor = D || InAppMessage.th.Eh, this.buttons = C || [], this.cropType = d || InAppMessage.CropType.FIT_CENTER, this.orientation = U, this.htmlId = b, this.css = P, this.isControl = !1, this.messageExtras = p, this.nh = !1, this.st = !1, this.Co = !1, this.Th = !1, this.We = null, this.Xe = null, this._t = new u(), this.oh = new u(), this["do"] = InAppMessage.TextAlignment.CENTER;
  }

  _createClass(InAppMessage, [{
    key: "subscribeToClickedEvent",
    value: function subscribeToClickedEvent(t) {
      return this._t.Ns(t);
    }
  }, {
    key: "subscribeToDismissedEvent",
    value: function subscribeToDismissedEvent(t) {
      return this.oh.Ns(t);
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(t) {
      this._t.removeSubscription(t), this.oh.removeSubscription(t);
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      this._t.removeAllSubscriptions(), this.oh.removeAllSubscriptions();
    }
  }, {
    key: "closeMessage",
    value: function closeMessage() {
      this.ll(this.We);
    }
  }, {
    key: "Ye",
    value: function Ye() {
      return !0;
    }
  }, {
    key: "Bo",
    value: function Bo() {
      return this.Ye();
    }
  }, {
    key: "Ve",
    value: function Ve() {
      return null != this.htmlId && this.htmlId.length > 4;
    }
  }, {
    key: "Oe",
    value: function Oe() {
      return this.Ve() && null != this.css && this.css.length > 0;
    }
  }, {
    key: "_e",
    value: function _e() {
      if (this.Ve() && this.Oe()) return this.htmlId + "-css";
    }
  }, {
    key: "wt",
    value: function wt() {
      return !this.st && (this.st = !0, !0);
    }
  }, {
    key: "ko",
    value: function ko() {
      return this.st;
    }
  }, {
    key: "rt",
    value: function rt(t) {
      return !this.Co && (this.Co = !0, this._t.X(), !0);
    }
  }, {
    key: "ft",
    value: function ft() {
      return !this.Th && (this.Th = !0, this.oh.X(), !0);
    }
  }, {
    key: "hide",
    value: function hide(t) {
      if (t && t.parentNode) {
        var s = t.closest(".ab-iam-root");

        if (null == s && (s = t), this.Ye() && null != s.parentNode) {
          var _t = s.parentNode.classList;
          _t && _t.contains(InAppMessage.rh) && _t.remove(InAppMessage.rh), document.body.removeEventListener("touchmove", InAppMessage.lh);
        }

        s.className = s.className.replace(InAppMessage.uh, InAppMessage.ah);
      }

      return this.animateOut || !1;
    }
  }, {
    key: "ll",
    value: function ll(t, s) {
      var _this = this;

      if (null == t) return;
      var i;
      this.We = null, i = -1 === t.className.indexOf("ab-in-app-message") ? t.getElementsByClassName("ab-in-app-message")[0] : t;
      var h = !1;
      i && (h = this.hide(i));
      var e = document.body;
      var E;
      null != e && (E = e.scrollTop);

      var n = function n() {
        if (t && t.parentNode) {
          var _s = t.closest(".ab-iam-root");

          null == _s && (_s = t), _s.parentNode && _s.parentNode.removeChild(_s);
        }

        var i = _this._e();

        if (null != i) {
          var _t2 = document.getElementById(i);

          _t2 && _t2.parentNode && _t2.parentNode.removeChild(_t2);
        }

        null != e && "Safari" === ro.browser && (e.scrollTop = E), s ? s() : _this.ft();
      };

      h ? setTimeout(n, InAppMessage.Ih) : n(), this.Xe && this.Xe.focus();
    }
  }, {
    key: "po",
    value: function po() {
      return document.createTextNode(this.message || "");
    }
  }, {
    key: "uo",
    value: function uo(t) {
      var s = "";
      this.message || this.header || !this.Ye() || (s = "Modal Image"), t.setAttribute("alt", s);
    }
  }, {
    key: "Ah",
    value: function Ah(t) {
      var s = t.parentNode;
      this.Ye() && null != s && this.orientation !== InAppMessage.Orientation.LANDSCAPE && (null != s.classList && s.classList.add(InAppMessage.rh), document.body.addEventListener("touchmove", InAppMessage.lh, !!Tt() && {
        passive: !1
      })), t.className += " " + InAppMessage.uh;
    }
  }, {
    key: "Lh",
    value: function Lh() {
      this.nh || r.sr(z.mh) || (document.addEventListener("keydown", InAppMessage.Oh, !1), r.Nh(function () {
        document.removeEventListener("keydown", InAppMessage.Oh);
      }), this.nh = !0);
    }
  }, {
    key: "Bs",
    value: function Bs(t) {
      var s = {};
      return t ? (s[InAppMessage.qt.ra] = this.message, s[InAppMessage.qt.sa] = this.messageAlignment, s[InAppMessage.qt.Sh] = this.slideFrom, s[InAppMessage.qt.St] = this.extras, s[InAppMessage.qt.ta] = this.triggerId, s[InAppMessage.qt.ia] = this.clickAction, s[InAppMessage.qt.URI] = this.uri, s[InAppMessage.qt.oa] = this.openTarget, s[InAppMessage.qt.pa] = this.dismissType, s[InAppMessage.qt.ma] = this.duration, s[InAppMessage.qt.na] = this.icon, s[InAppMessage.qt.Jt] = this.imageUrl, s[InAppMessage.qt.ua] = this.imageStyle, s[InAppMessage.qt.ca] = this.iconColor, s[InAppMessage.qt.fa] = this.iconBackgroundColor, s[InAppMessage.qt.da] = this.backgroundColor, s[InAppMessage.qt.la] = this.textColor, s[InAppMessage.qt.ga] = this.closeButtonColor, s[InAppMessage.qt.ja] = this.animateIn, s[InAppMessage.qt.xa] = this.animateOut, s[InAppMessage.qt.za] = this.header, s[InAppMessage.qt.ha] = this.headerAlignment, s[InAppMessage.qt.va] = this.headerTextColor, s[InAppMessage.qt.wa] = this.frameColor, s[InAppMessage.qt.ya] = this.buttons, s[InAppMessage.qt.Sa] = this.cropType, s[InAppMessage.qt.ba] = this.orientation, s[InAppMessage.qt.ka] = this.htmlId, s[InAppMessage.qt.CSS] = this.css, s[InAppMessage.qt.zt] = t, s[InAppMessage.qt.qa] = this.messageExtras, s) : s;
    }
  }], [{
    key: "lh",
    value: function lh(t) {
      if (t.targetTouches && t.targetTouches.length > 1) return;
      var s = t.target;
      s && s.classList && s.classList.contains("ab-message-text") && s.scrollHeight > s.clientHeight || document.querySelector(".".concat(InAppMessage.rh)) && t.cancelable && t.preventDefault();
    }
  }, {
    key: "Oh",
    value: function Oh(t) {
      if (t.keyCode === bt._h && !r.sr(z.mh) && document.querySelectorAll(".ab-modal-interactions").length > 0) {
        var _t3 = document.getElementsByClassName("ab-html-message");

        var s = !1;

        var _iterator = _createForOfIteratorHelper(_t3),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var i = _step.value;
            var _t5 = null;
            It(i) && i.contentWindow && (_t5 = i.contentWindow.document.getElementsByClassName("ab-programmatic-close-button")[0]), null != _t5 && (Et(_t5), s = !0);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (!s) {
          var _t4 = document.querySelectorAll(".ab-modal-interactions > .ab-close-button")[0];
          null != _t4 && Et(_t4);
        }
      }
    }
  }]);

  return InAppMessage;
}();

export { InAppMessage as default };
InAppMessage.th = {
  hh: 4281545523,
  ih: 4294967295,
  sh: 4278219733,
  Rh: 4293914607,
  Mh: 4283782485,
  Eh: 3224580915,
  eh: 4288387995
}, InAppMessage.lo = {
  Dh: "hd",
  Ze: "ias",
  Ch: "of",
  dh: "do",
  Uh: "umt",
  bh: "tf",
  Ph: "te"
}, InAppMessage.SlideFrom = {
  TOP: "TOP",
  BOTTOM: "BOTTOM"
}, InAppMessage.ClickAction = {
  NEWS_FEED: "NEWS_FEED",
  URI: "URI",
  NONE: "NONE"
}, InAppMessage.DismissType = {
  AUTO_DISMISS: "AUTO_DISMISS",
  MANUAL: "SWIPE"
}, InAppMessage.OpenTarget = {
  NONE: "NONE",
  BLANK: "BLANK"
}, InAppMessage.ImageStyle = {
  TOP: "TOP",
  GRAPHIC: "GRAPHIC"
}, InAppMessage.Orientation = {
  PORTRAIT: "PORTRAIT",
  LANDSCAPE: "LANDSCAPE"
}, InAppMessage.TextAlignment = {
  START: "START",
  CENTER: "CENTER",
  END: "END"
}, InAppMessage.CropType = {
  CENTER_CROP: "CENTER_CROP",
  FIT_CENTER: "FIT_CENTER"
}, InAppMessage.Qe = {
  jn: "SLIDEUP",
  dn: "MODAL",
  xo: "MODAL_STYLED",
  gn: "FULL",
  fn: "WEB_HTML",
  Le: "HTML",
  Io: "HTML_FULL"
}, InAppMessage.Ih = 500, InAppMessage.ph = 200, InAppMessage.uh = "ab-show", InAppMessage.ah = "ab-hide", InAppMessage.rh = "ab-pause-scrolling", InAppMessage.qt = {
  ra: "m",
  sa: "ma",
  Sh: "sf",
  St: "e",
  ta: "ti",
  ia: "ca",
  URI: "u",
  oa: "oa",
  pa: "dt",
  ma: "d",
  na: "i",
  Jt: "iu",
  ua: "is",
  ca: "ic",
  fa: "ibc",
  da: "bc",
  la: "tc",
  ga: "cbc",
  ja: "ai",
  xa: "ao",
  za: "h",
  ha: "ha",
  va: "htc",
  wa: "fc",
  ya: "b",
  Sa: "ct",
  ba: "o",
  ka: "hi",
  CSS: "css",
  zt: "type",
  Po: "messageFields",
  qa: "me"
};